import React, { useState } from "react";
import { ModalThemMoi } from "./ModalThemMoi";

export const BtnThemMoi = ({ onEdit }) => {
    const item = null;
    return (
            <button type="button" className="btn btn-border-new" style={{
                border: '1px solid #0D869B'
            }} onClick={() => onEdit(item)}>
                <span>
                    <img
                        src="/app-assets/images/icon-them-moi-cam-do-v2.png"
                        style={{ paddingBottom: "5px", marginRight: '6px' }}
                        alt="Thêm mới"
                    />
                    Thêm mới
                </span>
            </button>
    );
};
